import { c as _c } from "react/compiler-runtime";
import { EventWithData } from '../../../../../../../typings/Event.interface';
import { useCopyToClipboard } from '../../../../utils/copy';
import Badge from '../../../common/base/Badge';
import Button from '../../../common/base/Button';
import Divider from '../../../common/base/Divider';
import Text from '../../../common/base/Text';
import { BodyCollapsibleSection } from '../../../common/Data/Body';
import { Div } from '../../../common/helpers/StyledUtils';
import { HeadersCollapsibleSection } from '../../../common/Data/Headers';
import { QueryCollapsibleSection } from '../../../common/Data/Query';
export const EventHTTPRequest = t0 => {
  const $ = _c(59);
  const {
    event,
    embedded,
    hide_title,
    context_menu: t1
  } = t0;
  const context_menu = t1 === undefined ? false : t1;
  const copyToClipboard = useCopyToClipboard();
  const method = event.data.method;
  let t2;
  if ($[0] !== event.data.url) {
    t2 = event.data.url?.split("?")[0];
    $[0] = event.data.url;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const url = t2;
  const body = event.data?.body;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      direction: "column"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== embedded || $[4] !== hide_title) {
    t4 = !embedded && !hide_title && <Text bold={true} size="l" m={{
      t: 0,
      b: 4
    }}>HTTP Request</Text>;
    $[3] = embedded;
    $[4] = hide_title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = embedded ? "space-between" : "flex-start";
  let t6;
  if ($[6] !== t5) {
    t6 = {
      align: "center",
      gap: 2,
      justify: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = embedded ? 0 : 4;
  let t8;
  if ($[8] !== t7) {
    t8 = {
      b: t7
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = embedded ? 6 : 0;
  const t10 = embedded ? 3 : 0;
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = {
      x: t9,
      y: t10
    };
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      align: "center",
      gap: 2
    };
    t13 = {
      overflow: "hidden"
    };
    $[13] = t12;
    $[14] = t13;
  } else {
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] !== method) {
    t14 = <Badge neutral={true}>{method}</Badge>;
    $[15] = method;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = embedded ? 100 : undefined;
  let t16;
  if ($[17] !== t15 || $[18] !== url) {
    t16 = <Text mono={true} as="span" title={url} ellipsis={true} size="s" w={t15}>{url}</Text>;
    $[17] = t15;
    $[18] = url;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t14 || $[21] !== t16) {
    t17 = <Div flex={t12} style={t13}>{t14}{t16}</Div>;
    $[20] = t14;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== copyToClipboard || $[24] !== url) {
    t18 = <Button ghost={true} onClick={() => copyToClipboard(url)} icon="copy" />;
    $[23] = copyToClipboard;
    $[24] = url;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t11 || $[27] !== t17 || $[28] !== t18 || $[29] !== t6 || $[30] !== t8) {
    t19 = <Div flex={t6} m={t8} p={t11}>{t17}{t18}</Div>;
    $[26] = t11;
    $[27] = t17;
    $[28] = t18;
    $[29] = t6;
    $[30] = t8;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== embedded) {
    t20 = embedded && <Divider />;
    $[32] = embedded;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== event.data.headers) {
    t21 = event.data?.headers || {};
    $[34] = event.data.headers;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  const t22 = event.data && "appended_headers" in event.data ? event.data.appended_headers : undefined;
  const t23 = !!embedded;
  const t24 = !!embedded;
  let t25;
  if ($[36] !== t21 || $[37] !== t22 || $[38] !== t23 || $[39] !== t24) {
    t25 = <HeadersCollapsibleSection headers={t21} appended_headers={t22} embedded={t23} context_menu={t24} />;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== embedded || $[42] !== event.data.parsed_query || $[43] !== event.data.query) {
    t26 = event.data?.query && <QueryCollapsibleSection query={event.data?.query} parsed_query={event.data?.parsed_query || {}} embedded={!!embedded} context_menu={!!embedded} />;
    $[41] = embedded;
    $[42] = event.data.parsed_query;
    $[43] = event.data.query;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== body || $[46] !== context_menu || $[47] !== embedded || $[48] !== event.data.body_format || $[49] !== event.data.headers || $[50] !== event.id) {
    t27 = (body || event.data?.body_format === "binary") && <BodyCollapsibleSection body={body ?? null} body_format={event.data?.body_format} headers={event.data?.headers} embedded={!!embedded} type="event" id={event.id} context_menu={context_menu} />;
    $[45] = body;
    $[46] = context_menu;
    $[47] = embedded;
    $[48] = event.data.body_format;
    $[49] = event.data.headers;
    $[50] = event.id;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t19 || $[53] !== t20 || $[54] !== t25 || $[55] !== t26 || $[56] !== t27 || $[57] !== t4) {
    t28 = <Div flex={t3}>{t4}{t19}{t20}{t25}{t26}{t27}</Div>;
    $[52] = t19;
    $[53] = t20;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
    $[57] = t4;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  return t28;
};